import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import MaterialTable from "material-table";
import TablePagination from "@material-ui/core/TablePagination";
import UiUtils from "../../../provider/UiUtils";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import Utils from "../../../provider/Utils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import { ApEmailTemplateList_Url } from "../../../provider/ServiceUrl";
import AdminPaginationRowAction from "../../../redux/adminPanel/paginationRow/AdminPaginationRowAction";

class EmailTemplateList extends Component {
  title = "Email Template List";
  breadCrumb = [{ pageid: "", uiname: "Email Template List" }];
  header = store.getState().adminHeader.adminHeader;
  emailTemplateState = store.getState().applicationState.emailTemplateState;
  adminPaginationState = store.getState().adminPaginations.emailTemplatesState;
  emailTemplateDetails = {};
  adminPaginationStateDetails = {};
  constructor(props) {
    super(props);
    if (this.emailTemplateState) {
      this.emailTemplateDetails = Object.getOwnPropertyNames(
        this.emailTemplateState
      );
    }
    if (this.adminPaginationState) {
      this.adminPaginationStateDetails = Object.getOwnPropertyNames(
        this.adminPaginationState
      );
    }
    if (this.emailTemplateDetails.length > 0) {
      this.state = {
        emailTemplateList: [],
        isPaging: false,
        initialPage: this.emailTemplateState.initialPage,
        pageSize: this.emailTemplateState.pageSize,
        emailTemplateId: this.emailTemplateState.emailTemplateId,
        searchText: this.emailTemplateState.searchText,
        render: false,
      };
    } else {
      this.state = {
        emailTemplateList: [],
        isPaging: false,
        initialPage: 0,
        pageSize:
          this.adminPaginationStateDetails?.length > 0
            ? this.adminPaginationState?.pageSize
            : 20,
        emailTemplateId: "",
        searchText: "",
        tableKey: Date.now(),
        render: false,
      };
    }
    this.getEmailTemplateList();
  }

  getEmailTemplateList() {
    const postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(
      ApEmailTemplateList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let emailTemplateList = output.data.templateList;
        for (let i = 0; i < emailTemplateList.length; i++) {
          emailTemplateList[i].updatedOn = emailTemplateList[i].updatedOn !== null
            ? Utils.getUtcToLocal(emailTemplateList[i].updatedOn)
            : ""
        }
        let isPaging = false;
        if (emailTemplateList.length > 20) {
          isPaging = true;
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          emailTemplateList: emailTemplateList,
        });
      }
    });
  }

  toEmailTemplateDetails(e, data) {
    let emailTemplateState = {
      emailTemplateId: data.id,
      searchText: this.state.searchText,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ emailTemplateState })
    );
    this.props.navigate("/emailTemplate", {
      state: {
        action: "view",
        title: "Email Template Details",
        emailTemplateId: data.id,
        pageId: "sponsorList",
      },
    });
  }

  handleMaterialTablePageChange(page, pageSize) {
    let emailTemplatesState = {
      initialPage: page,
      pageSize: pageSize,
    };
    store.dispatch(
      AdminPaginationRowAction.setEmailTemplatesPaginationState({ emailTemplatesState })
    );
    this.setState({ initialPage: page, pageSize: pageSize });
  }
  handleSearchChange(searchText) {
    let emailTemplateState = {
      emailTemplateId: this.state.emailTemplateId,
      searchText: searchText,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ emailTemplateState })
    );
    this.setState({ searchText: searchText });
  }
  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            name={this.title}
            isSearchText={this.state.searchText !== ""}
          />
          <div style={{ maxWidth: "100%" }}>
            <MaterialTable
              onRowClick={(event, rowData) => {
                this.toEmailTemplateDetails(event, rowData);
                event.stopPropagation();
              }}
              icons={UiUtils.getMaterialTableIcons()}
              title=""
              columns={[
                {
                  title: "#",
                  render: (rowData) => rowData.tableData.id + 1,

                  width: "6%",
                  align: "left",
                },
                {
                  title: "UID",
                  field: "uid",
                  hidden: true,
                  searchable: true,
                },
                {
                  title: "Subject",
                  field: "subject",
                  cellStyle: {
                    width: "40%",
                  },
                },
                {
                  title: "Description",
                  field: "description",
                  cellStyle: {
                    width: "40%",
                  },
                },
                {
                  title: "Last Update",
                  field: "updatedOn",
                  searchable: true,
                  cellStyle: {
                    width: "15%",
                  },
                },
              ]}
              data={this.state.emailTemplateList}
              onChangePage={(page, pageSize) => {
                this.handleMaterialTablePageChange(page, pageSize);
              }}
              onSearchChange={(searchText) => {
                this.handleSearchChange(searchText);
              }}
              options={{
                sorting: true,
                search: true,
                searchText: this.state.searchText,
                emptyRowsWhenPaging: false,
                actionsColumnIndex: -1,
                initialPage: this.state.initialPage,
                pageSize: this.state.pageSize,
                headerStyle: {
                  backgroundColor: "#37517e",
                  fontWeight: "bold",
                  color: "#fff",
                  align: "left",
                },
                pageSizeOptions: Utils.materialTablePageSize(),
                paging: this.state.isPaging,
                rowStyle: (rowData) => ({
                  backgroundColor:
                    rowData.id === this.state.emailTemplateId
                      ? "#e6effc"
                      : "#fff",
                  height: "3em",
                  textTransform: "capitalize",
                }),

                tableLayout: "auto",
              }}
              components={{
                Pagination: (props) => {
                  const {
                    page,
                    count,
                    rowsPerPage,
                    onPageChange,
                    onRowsPerPageChange,
                  } = props;

                  const totalPages = Math.ceil(count / rowsPerPage);
                  const currentPage = page + 1;

                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 1rem",
                      }}
                    >
                      <div>
                        Page {currentPage} of {totalPages}
                      </div>
                      <TablePagination
                        {...props}
                        rowsPerPageOptions={props.rowsPerPageOptions}
                        component="div"
                        count={count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={onPageChange}
                        onRowsPerPageChange={onRowsPerPageChange}
                      />
                    </div>
                  );
                },
              }}
            />
          </div>
        </>
      );
    }
  }
}

export default withRouter(EmailTemplateList);
